import { render, staticRenderFns } from "./LogPage.vue?vue&type=template&id=945d31b4&"
import script from "./LogPage.vue?vue&type=script&lang=js&"
export * from "./LogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports